import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  domainName: "",
  BannerImage: "",
};

const domainSlice = createSlice({
  name: "domain",
  initialState,
  reducers: {
    // Action to set the domain name
    setDomainName: (state, action) => {
      state.domainName = action.payload;
    },
    setBannerImage: (state, action) => {
      state.BannerImage = action.payload;
    }
  },
});

// Export actions
export const { setDomainName, setBannerImage } = domainSlice.actions;

// Export reducer
export default domainSlice.reducer;
